<template>
    <div v-if="data && data.module_key">
        <BituminousConcreteOverlay :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-if="data.module_key == 'mm_bituminous_concrete_overlay'"/>
        <DenseBituminousConcreteOverlay :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_dense_bituminous_concrete_overlay'"/>
        <Milling :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_milling'"/>
        <ThermoplasticRoadMarking :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_thermoplastic_road_marking'"/>
        <ShoulderRaising :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_shoulder_raising'"/>
        <RoadSrudsFixing :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_road_sruds_fixing'"/>
        <KerbTopping :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_kerb_topping'"/>
        <KerbPainting :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_kerb_painting'"/>
        <MicroSurfacing :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_microsurfacing'"/>
        <TackCoat :data.sync="data_obj" :api_errors="api_errors" :mode="mode" v-else-if="data.module_key == 'mm_tack_coat'"/>
    </div>
</template>

<script>

import BituminousConcreteOverlay from "./DPREntry/BituminousConcreteOverlay.vue"
import DenseBituminousConcreteOverlay from "./DPREntry/DenseBituminousConcreteOverlay.vue"
import Milling from "./DPREntry/Milling.vue";
import ThermoplasticRoadMarking from "./DPREntry/ThermoplasticRoadMarking.vue";
import ShoulderRaising from "./DPREntry/ShoulderRaising.vue";
import RoadSrudsFixing from "./DPREntry/RoadSrudsFixing.vue";
import KerbTopping from "./DPREntry/KerbTopping.vue";
import KerbPainting from "./DPREntry/KerbPainting.vue";
import MicroSurfacing from "./DPREntry/MicroSurfacing.vue";
import TackCoat from "./DPREntry/TackCoat.vue";

export default {
    props: {
        data: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        }
    },
    components: {
        BituminousConcreteOverlay,
        DenseBituminousConcreteOverlay,
        Milling,
        ThermoplasticRoadMarking,
        ShoulderRaising,
        RoadSrudsFixing,
        KerbTopping,
        KerbPainting,
        MicroSurfacing,
        TackCoat
    },
    data() {
        return {
            data_obj: this.data,
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_data_obj(newV)
            }
        },
        data_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:data', newV)
            }
        }
    },
    mounted() {
        this.update_data_obj(this.data)
    },
    methods: {
        update_data_obj(new_data) {
            if (!new_data) this.data_obj = null
            else {
                let data_obj = {...new_data}
                if (!data_obj.data)
                    data_obj.data = {}
                
                this.data_obj = data_obj
            }
        }
    }
}
</script>
